<template>
  <div>
    <v-card tile>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Nuevo Consumo</h3>
              </v-chip>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="fechaConsumo"
                :value="fechaConsumo"
                label="Fecha Consumo *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="descripcion"
                prepend-icon="mdi-account"
                label="Descripcion"
                dense
                maxlength="200"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="total"
                prepend-icon="mdi-currency-usd"
                :rules="totalRules"
                label="Importe *"
                @blur="toFixed"
                @keypress="onlyNumber"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!valid" @click.stop="guardarConsumo"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-form>
      <v-card-text v-if="idTurno > 0 || idInscripcion > 0">
        <v-row dense>
          <v-col cols="12" style="margin-top: 3px">
            <v-chip class="ma-0" label color="transparent" text-color="black">
              <h3>
                Consumos ya realizados para este
                {{ idTurno > 0 ? "turno" : "jugador" }}
              </h3>
            </v-chip>
          </v-col>
        </v-row>

        <v-data-table
          v-if="listaConsumos.length"
          :headers="headers"
          :items="this.listaConsumos"
          class="elevation-1"
          :hide-default-footer="true"
          locale="es-ar"
          item-key="idCrobro"
          :items-per-page="10000"
          ref="myTable"
          :disable-sort="true"
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="purple"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="editarConsumo(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar consumo</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  v-on="on"
                  class="mr-3"
                  color="red"
                  v-bind="attrs"
                  @click="borrarConsumo(item)"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Eliminar consumo</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-alert class="mt-4" color="purple" dark outlined v-else>
          No hay consumos realizados para
          {{ idTurno > 0 ? "este turno" : "este jugador" }}.
        </v-alert>
      </v-card-text>
      <EditarConsumo
        :visible="showEditarConsumo"
        :idConsumo="editedItem.idConsumo"
        @close="cierraEditarConsumo($event)"
      ></EditarConsumo>
    </v-card>
  </div>
</template>
<script>
import moment from "moment";
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";
import EditarConsumo from "./EditarConsumo.vue";

export default {
  props: {
    idTurno: {
      required: false,
      default: 0,
    },
    idInscripcion: {
      required: false,
      default: 0,
    },
  },
  components: {
    EditarConsumo,
  },
  data() {
    return {
      valid: false,
      lazy: false,
      fechaConsumo: null,
      descripcion: "",
      total: null,
      requiredRules: [(v) => !!v || "Dato obligatorio"],
      totalRules: [
        (v) => !!v || "Dato obligatorio",
        (v) => v > 0 || "El total debe ser mayor a 0",
      ],
      listaConsumos: [],
      headers: [
        { text: "Fecha", value: "fechaString" },
        { text: "Descripción", value: "descripcion" },
        { text: "Importe", value: "totalString" },
        { text: "Acciones", value: "actions" },
      ],
      showEditarConsumo: false,
      editedItem: {},
    };
  },
  methods: {
    editarConsumo(item) {
      this.editedItem.idConsumo = item.idConsumo;
      this.showEditarConsumo = true;
    },
    cierraEditarConsumo() {
      if (this.idTurno > 0 || this.idInscripcion > 0) {
        this.buscarConsumosTurno();
      }
      this.showEditarConsumo = false;
    },
    toFixed() {
      if (isNaN(parseFloat(this.total)))
        this.total = parseFloat(0.0).toFixed(2);
      else this.total = parseFloat(this.total).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    vaciarModels() {
      this.descripcion = "";
      this.total = "";
      this.fechaConsumo = moment().format("YYYY-MM-DD");
    },
    guardarConsumo() {
      if (moment(this.fechaConsumo).isBefore(moment("1900-01-01"))) {
        showAlert({
          icon: "warning",
          title: "La fecha del consumo debe ser mayor o igual al 01/01/1900.",
          timer: 2500,
          vm: this,
        });
        return;
      }
      this.$swal({
        title: "Registrar consumo",
        text: "¿Desea registrar el consumo?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosConsumo = {
            fecha: this.fechaConsumo,
            idTurno: this.idTurno,
            idInscripcion: this.idInscripcion,
            total: this.total,
            descripcion: this.descripcion,
            usuario: this.$store.state.usuario.usuario,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          };
          let self = this;
          axios
            .post("/Caja/GuardarConsumo", datosConsumo)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              self.buscarConsumosTurno();
              document.getElementsByClassName(
                "v-dialog--active"
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title: "Consumo registrado.",
                vm: self,
                timer: 2000,
              });
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El consumo no pudo ser registrado.",
                vm: this,
                timer: 2000,
              });
            });
        }
      });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    buscarConsumosTurno() {
      const filtrosData = {
        idTurno: this.idTurno,
        idInscripcion: this.idInscripcion,
      };

      let self = this;
      axios
        .get("/Caja/BuscarConsumosTurno?", {
          params: {
            idTurno: filtrosData.idTurno,
            idInscripcion: filtrosData.idInscripcion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaConsumos = response.data;
          else self.listaConsumos = [];
        })
        .catch(function (error) {
          self.listaConsumos = [];
        })
        .finally(() => {
          const total = self.listaConsumos.reduce(
            (acc, curr) => (acc = acc + curr.total),
            0
          );

          self.$emit("actualizarTotal", total);
        });
    },
    borrarConsumo(item) {
      this.$swal({
        title: "Borrar consumo",
        text: "¿Desea borrar el consumo?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios
            .get("/Caja/BorrarConsumo?", {
              params: {
                idConsumo: item.idConsumo,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Consumo borrado.",
                vm: self,
                timer: 2000,
              });
              if (self.idTurno > 0 || self.idInscripcion > 0) {
                setTimeout(self.buscarConsumosTurno(), 1700);
              }
              this.delta = true;
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El consumo no pudo ser borrado.",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
  },
  created() {
    this.fechaConsumo = moment().format("YYYY-MM-DD");
    this.buscarConsumosTurno();
  },
};
</script>
